/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateIntegratorUserOptions,
  CreateIntegratorUserStatus201,
  CreateIntegratorUserStatus400,
  CreateIntegratorUserStatus409,
  CreateIntegratorUserStatus500,
} from '../types/CreateIntegratorUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createIntegratorUser } from '../clients/createIntegratorUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createIntegratorUserMutationKey = () => [{ url: '/v1/integrators/user' }] as const

export function createIntegratorUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createIntegratorUserMutationKey()
  return mutationOptions<
    CreateIntegratorUserStatus201,
    ResponseErrorConfig<
      CreateIntegratorUserStatus400 | CreateIntegratorUserStatus409 | CreateIntegratorUserStatus500
    >,
    CreateIntegratorUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createIntegratorUser({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Create a new user
 * {@link /v1/integrators/user}
 */
export function useCreateIntegratorUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateIntegratorUserStatus201,
      ResponseErrorConfig<
        | CreateIntegratorUserStatus400
        | CreateIntegratorUserStatus409
        | CreateIntegratorUserStatus500
      >,
      CreateIntegratorUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createIntegratorUserMutationKey()

  const baseOptions = createIntegratorUserMutationOptions(config) as UseMutationOptions<
    CreateIntegratorUserStatus201,
    ResponseErrorConfig<
      CreateIntegratorUserStatus400 | CreateIntegratorUserStatus409 | CreateIntegratorUserStatus500
    >,
    CreateIntegratorUserOptions,
    TContext
  >

  return useMutation<
    CreateIntegratorUserStatus201,
    ResponseErrorConfig<
      CreateIntegratorUserStatus400 | CreateIntegratorUserStatus409 | CreateIntegratorUserStatus500
    >,
    CreateIntegratorUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateIntegratorUserStatus201,
    ResponseErrorConfig<
      CreateIntegratorUserStatus400 | CreateIntegratorUserStatus409 | CreateIntegratorUserStatus500
    >,
    CreateIntegratorUserOptions,
    TContext
  >
}
